interface GrantTypeConstant {
  form: string;
  refreshToken: string;
}

const GrantTypeConstant: any = {
  form: 'form',
  refreshToken: 'refresh_token',
  reference: 'reference',
};

export default GrantTypeConstant;
